import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { Typography, Box, Divider } from '@mui/material';
import { theme } from '../../theme';

type Props = {
  children: string;
};

const CustomMarkdown: React.FC<Props> = ({ children }) => {
  return (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      components={{
        p: ({ children }) => (
          <Typography
            component="p"
            variant="body2"
            sx={{ color: theme.palette.custom.markdownText, mb: 1 }}
          >
            {children}
          </Typography>
        ),
        strong: ({ children }) => (
          <strong style={{ color: theme.palette.custom.markdownStrong }}>
            {children}
          </strong>
        ),
        em: ({ children }) => (
          <em style={{ fontStyle: 'italic', color: theme.palette.custom.markdownEm }}>
            {children}
          </em>
        ),
        a: ({ href, children }) => (
          <a
            href={href}
            style={{ color: theme.palette.custom.markdownLink }}
            target="_blank"
            rel="noreferrer"
          >
            {children}
          </a>
        ),
        blockquote: ({ children }) => (
          <Box
            component="blockquote"
            sx={{
              borderLeft: `3px solid ${theme.palette.custom.markdownQuoteBorder}`,
              pl: 2,
              my: 2,
              fontStyle: 'italic',
              color: theme.palette.custom.markdownQuoteText,
            }}
          >
            {children}
          </Box>
        ),
        hr: () => (
          <Divider sx={{ borderColor: theme.palette.custom.markdownDivider, my: 2 }} />
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  );
};

export default CustomMarkdown;
